import { render, staticRenderFns } from "./BuyingSummaryModal.vue?vue&type=template&id=7436c110&scoped=true&"
import script from "./BuyingSummaryModal.vue?vue&type=script&lang=js&"
export * from "./BuyingSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyingSummaryModal.vue?vue&type=style&index=0&id=7436c110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7436c110",
  null
  
)

export default component.exports